import { render, staticRenderFns } from "./HatchCover.vue?vue&type=template&id=8fafe07e&scoped=true"
import script from "./HatchCover.vue?vue&type=script&lang=ts"
export * from "./HatchCover.vue?vue&type=script&lang=ts"
import style0 from "./HatchCover.vue?vue&type=style&index=0&id=8fafe07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fafe07e",
  null
  
)

export default component.exports